const scalingFactor = 0.45;

export default function (marquee) {
	const [marqueeText1, marqueeText2] = marquee.children;
	let frame = null;
	let resizeTimeout;

	function handleScroll() {
		const { top: top1 } = marqueeText1.getBoundingClientRect();
		const { bottom: bottom2 } = marqueeText2.getBoundingClientRect();

		if (bottom2 > 0 && top1 < window.innerHeight) {
			const percentageScrolled1 = ((top1 / window.innerHeight) * scalingFactor) * 100;
			const percentageScrolled2 = ((bottom2 / window.innerHeight) * scalingFactor) * 100;

			marqueeText1.style.transform = `translate3d(${percentageScrolled1}%, 0, 0)`;
			marqueeText2.style.transform = `translate3d(-${percentageScrolled2}%, 0, 0)`;
		}
	}

	document.addEventListener('scroll', () => {
		if (frame) return;

		frame = requestAnimationFrame(() => {
			frame = null;
			handleScroll();
		});
	});

	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(handleScroll, 150);
	});
}
